import "bootstrap/dist/js/bootstrap.bundle.min.js";

import {
  PAYPAL_APPLY_LINK_ID,
  PAYPAL_CREDIT_PROD_URL_UK,
  PAYPAL_CREDIT_PROD_URL_US,
  PAYPAL_CREDIT_QA_URL_UK,
  PAYPAL_CREDIT_QA_URL_US,
  PAYPAL_FAQ_LINK_ID,
  UK,
  US,
} from "../../../../../common/constants";
import { triggerTracking } from "../../../../../utility/tracking";
export interface Input {
  site?: string;
}
export interface State {}
export default class AppFooter extends Marko.Component<Input, State> {
  openPaypal() {
    const env = process.env.NODE_ENV;
    const width = 420;
    const height = 770;
    let center_top,
      redirectUrl = "";
    const ch_container = document.getElementById("credits-header-container");
    const position_left = ch_container?.offsetLeft || 0;
    const position_top = ch_container?.offsetTop || 0;
    const winLeft = window.screenLeft ? window.screenLeft : window.screenX;
    const winTop = window.screenTop ? window.screenTop : window.screenY;

    if (env === "production" && this.input.site === UK)
      redirectUrl = PAYPAL_CREDIT_PROD_URL_UK;
    else if (env === "production" && this.input.site == US)
      redirectUrl = PAYPAL_CREDIT_PROD_URL_US;
    else if (env === "development" && this.input.site === UK)
      redirectUrl = PAYPAL_CREDIT_QA_URL_UK;
    else if (env === "development" && this.input.site === US)
      redirectUrl = PAYPAL_CREDIT_QA_URL_US;

    triggerTracking(PAYPAL_APPLY_LINK_ID);

    if (screen.width > 480) {
      const center_left = winLeft + position_left - 80;
      if (winTop > 100) center_top = position_top + winTop + 80;
      else center_top = position_top + winTop;

      const my_window = window.open(
        redirectUrl,
        "Title",
        `toolbar=no, location=no, directories=no, status=no, menubar=no, copyhistory=no, scrollbars=1, width=${width}, height=${height}, left=${center_left}, top=${center_top}`,
      );

      my_window?.focus();
    } else {
      window.open(redirectUrl, "msgwindow", "_blank");
    }
  }

  trackPaypalFaq() {
    triggerTracking(PAYPAL_FAQ_LINK_ID);
  }
}
